@if (cancelInfoVm$ | async; as meetingDetails) {
<div class="container main-container">
  <div class="meeting-info-header">
    <div class="cancel-icon-container">
      <mat-icon class="cancel-icon">highlight_off</mat-icon>
    </div>
    <p class="header-text" i18n="@@CANCEL_INFO.TITLE">
      {{ 'CANCEL_INFO.TITLE' | translate }}
    </p>
    <p class="secondary-text-color subtitle-text" i18n="@@CANCEL_INFO.SUBTITLE">
      {{ 'CANCEL_INFO.SUBTITLE' | translate }}
    </p>
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">person</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.DETAILS">
        {{ 'CANCEL_INFO.DETAILS' | translate }}
      </div>
    </div>
    <div class="component-body profile-backdrop">
      <p class="primary-text">{{ meetingDetails.displayTitle }}</p>
      <p class="secondary-text-color">
        with {{ meetingDetails.hostNamesText }}
      </p>
    </div>
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">today</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.WHEN">
        {{ 'CANCEL_INFO.WHEN' | translate }}
      </div>
    </div>
    <div class="component-body calendar-backdrop">
      <p class="primary-text">{{ meetingDetails.dateText }}</p>
      <div class="flex-space-between">
        <div class="secondary-text-color">
          {{ meetingDetails.timeRangeText }}
          {{ meetingDetails.timezoneZoneText }}
        </div>
        <div class="display-duration">{{ meetingDetails.durationText }}</div>
      </div>
    </div>
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">location_on</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.WHERE">
        {{ 'CANCEL_INFO.WHERE' | translate }}
      </div>
    </div>
    @if (meetingDetails.isBatch && meetingDetails.isInPerson) {
      @for (meeting of meetingDetails.meetings; track meeting.meetingId) {
        @if (meeting.isInPerson && meeting.location) {
        <div class="component-body location-backdrop location-centered batch-meeting-link-box">
          <p class="batch-meeting-title">{{ meeting.eventTypeName }}</p>
          <span class="primary-text capitalize-first strikethrough">{{ meeting.location }}</span>
        </div>
        } @else {
        <div class="component-body secondary-text-color location-backdrop location-centered batch-meeting-link-box">
          {{ meeting.eventTypeName }} -
          <span i18n="@@CANCEL_INFO.ONLINE_APPOINTMENT">{{
            'CANCEL_INFO.ONLINE_APPOINTMENT' | translate
          }}</span>
        </div>
        }
      }
    } @else if (meetingDetails.isBatch && !meetingDetails.isInPerson) {
      <div class="component-body secondary-text-color location-backdrop location-centered">
        <span i18n="@@CANCEL_INFO.ONLINE_APPOINTMENT">{{
          'CANCEL_INFO.ONLINE_APPOINTMENT' | translate
        }}</span>
      </div>
    } @else {
      @if (meetingDetails.isInPerson) {
      <div class="component-body location-backdrop location-centered">
        <span class="primary-text capitalize-first strikethrough">{{
          meetingDetails.meetingInfo.location
        }}</span>
      </div>
      } @else {
      <div class="component-body secondary-text-color location-backdrop location-centered">
        <span i18n="@@CANCEL_INFO.ONLINE_APPOINTMENT">{{
          'CANCEL_INFO.ONLINE_APPOINTMENT' | translate
        }}</span>
      </div>
      }
    }
  </div>
  <div class="section-gap">
    <div class="header-details">
      <mat-icon class="icon">comment</mat-icon>
      <div class="header-title" i18n="@@CANCEL_INFO.REASON">
        {{ 'CANCEL_INFO.REASON' | translate }}
      </div>
      <span class="optional-badge" i18n="@@CANCEL_INFO.OPTIONAL">{{
        'CANCEL_INFO.OPTIONAL' | translate : { Default: 'optional' }
      }}</span>
    </div>
    <div class="cancellation-reason-box">
      <textarea
        class="cancellation-reason-textarea"
        [(ngModel)]="cancellationReason"
        placeholder="Please enter a reason for cancellation."
        i18n-placeholder="@@CANCEL_INFO.REASON_PLACEHOLDER"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="5"
      ></textarea>
    </div>
  </div>
  <div class="section-gap info-banner">
    <mat-icon class="info-icon">info</mat-icon>
    <span i18n="@@CANCEL_INFO.INFO_BANNER">{{
      'CANCEL_INFO.INFO_BANNER' | translate
    }}</span>
  </div>
  <div class="section-gap action-buttons">
    <button
      mat-stroked-button
      class="reschedule-button"
      (click)="rescheduleInstead()"
    >
      <span i18n="@@CANCEL_INFO.RESCHEDULE_INSTEAD">{{
        'CANCEL_INFO.RESCHEDULE_INSTEAD' | translate
      }}</span>
    </button>
    <button
      mat-flat-button
      color="warn"
      class="cancel-button"
      (click)="cancelAppointment()"
      [disabled]="isCancelling"
    >
      <span i18n="@@CANCEL_INFO.CANCEL_BUTTON">{{
        'CANCEL_INFO.CANCEL_BUTTON' | translate
      }}</span>
    </button>
  </div>
  @if (error) {
  <div class="error-message section-gap">
    <mat-icon color="warn">error_outline</mat-icon>
    <span i18n="@@CANCEL.PROBLEM_CANCELLING">{{
      'CANCEL.PROBLEM_CANCELLING' | translate
    }}</span>
  </div>
  } @if (meetingDetails.meetingInfo.businessLogo) {
  <div class="section-gap-sm logo-container">
    <img
      [src]="meetingDetails.meetingInfo.businessLogo"
      alt="Business Logo"
      class="business-logo"
    />
  </div>
  }
</div>
} @else {
<div class="row row-gutters">
  @for (i of [].constructor(6); track i) {
  <div class="col col-xs-12 col-sm-6">
    <div class="stencil-shimmer meeting-type-card">
      <div
        class="meeting-type-icon mat-elevation-z2 stencil-shimmer disappear-on-mobile"
      ></div>
    </div>
  </div>
  }
</div>
}
